<template>
  <div>
    <v-btn color="primary" text @click="openDialog" class="text-none">
      <v-icon left>mdi-message-text</v-icon>
      GỬI TIN NHẮN ĐẾN APP
    </v-btn>
    <v-dialog v-model="dialog" max-width="800px" persistent scrollable>
      <BaseBodyDialog
        :title="dialogTitle"
        saveTitle="Xác nhận gửi"
        :loading="loading"
        @close="closeDialog"
        @save="onSend"
      >
        <v-alert v-if="!students.length" type="warning" text dense> Chưa có dữ liệu học sinh để gửi tin nhắn </v-alert>

        <v-card outlined class="elevation-0 mt-6">
          <v-card-text class="mb-2">
            <div class="text-body-2">
              Bảng dưới đây cho phép bạn tuỳ chỉnh học sinh nào sẽ <strong>nhận được thông báo</strong>.<br />
              Nếu bạn không chọn học sinh nào, hệ thống sẽ <strong>gửi thông báo đến toàn bộ học sinh trong danh sách</strong>.
            </div>
          </v-card-text>
          <v-data-table
            v-model="selectedStudents"
            :headers="headers"
            :items="students"
            item-key="id"
            show-select
            class="elevation-0"
            :loading="loading"
            no-data-text="Danh sách trống"
            loading-text="Đang tải danh sách học sinh..."
            :footer-props="{
              itemsPerPageText: 'Số dòng mỗi trang:',
              itemsPerPageAllText: 'Tất cả',
            }"
          >
            <template #[`item.student`]="{ item }">
              <div class="font-weight-medium">{{ $_get(item, 'student.name', '-') }}</div>
            </template>
            <template #[`item.status`]="{ item }">
              <v-chip :color="getStatusColor(item.status)" small text-color="white">
                {{ getStatusText(item.status) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </BaseBodyDialog>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  components: { BaseBodyDialog },
  props: { id: String, date: String },
  data: () => ({ dialog: false, selectedStudents: [], students: [], loading: false }),
  computed: {
    ...mapState({
      classData(state) {
        return state['class'].clazz
      },
    }),
    ...mapGetters('auth', ['profile']),
    headers() {
      return [
        { text: 'Học sinh', value: 'student' },
        { text: 'Trạng thái điểm danh', value: 'status', align: 'center' },
      ]
    },
    dialogTitle() {
      const readableDate = moment(this.date).format('DD/MM/YYYY')
      return `Gửi thông báo điểm danh cho buổi học ngày ${readableDate}`
    },
  },
  methods: {
    ...mapActions('postCreate', ['sendDiligence']),
    ...mapActions('lessonAttendance', ['fetchAttendancesIndependent']),
    async openDialog() {
      this.students = await this.fetchAttendancesIndependent({ lesson: this.id })
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSend() {
      this.loading = true
      const params = {
        classTitle: this.classData.title,
        lessonIds: [this.id],
        staff: this.profile.id,
      }
      if (this.selectedStudents.length) params['studentIds'] = this.selectedStudents.map((x) => x.student.id)
      await this.sendDiligence(params)
      this.loading = false
      this.closeDialog()
    },
    getStatusColor(status = '') {
      switch (status) {
        case 'attended':
          return 'success'
        case 'absent':
          return 'error'
        default:
          return 'grey'
      }
    },
    getStatusText(status = '') {
      switch (status) {
        case 'attended':
          return 'Có mặt'
        case 'absent':
          return 'Vắng mặt'
        default:
          return 'Chưa điểm danh'
      }
    },
  },
}
</script>
